<template>
    <div style="background-color: #f2f2f2">
        <MyFeedHeader title="레슨권"></MyFeedHeader>
        <InfinityScroll style="overflow:auto; flex:1;" :refresh-action="refresh">
            <div style="height:20px;"></div>
            <div v-for="each, i in memberships" class="membership_wrap" :key="i">
                <div style="display:flex; flex-direction: column;">
                    <template v-if="each.expire === '0'">
                        <div style="background-color: #ff7703;border-top-left-radius: 10px; border-top-right-radius: 10px; color:white; padding:5px; ">
                            <div style="margin-top:25px; padding-left:8px; font-size:16px; font-weight: normal;">{{each.membership_name}}<span style="float:right; margin-right:10px;">진행중</span></div>
                            <div style="font-size:12px; margin-top:5px; text-align:right;">&nbsp;</div>
                        </div>
                        <div style="position:relative; padding:15px 40px; padding-bottom:30px;background-color: white; border-bottom-right-radius: 10px; border-bottom-left-radius:10px; ">
                            <div style="font-size:17px; font-weight: bold; color:#464646; margin-top:5px;">{{$GlobalStore.loginInfo().name}}</div>
                            <div class="membership_info" style="margin-top:10px;">
                                <div class="membership_label">회원권</div><div class="membership_conts">{{each.membership_name}}</div>
                            </div>
                            <div class="membership_info">
                                <div class="membership_label">기간</div><div class="membership_conts">{{each.begin_date | ShortDotDate}} ~ {{each.end_date | ShortDotDate}}</div>
                            </div>
                            <div class="membership_info">
                                <div class="membership_label">회차</div><div class="membership_conts">{{each.coupon_count == 0 ? '무제한' : parseInt(each.used_count) + '회 / ' + each.coupon_count + '회'}}</div>
                            </div>
                            <div style="left:-20px;" class="round"></div>
                            <div style="right:-20px;" class="round"></div>
                        </div>
                    </template>
                    <template v-else>
                        <div style="background-color: #9b9b9b;border-top-left-radius: 10px; border-top-right-radius: 10px; color:white; padding:5px; ">
                            <div style="margin-top:25px; padding-left:8px; font-size:16px; font-weight: normal; color:#cdcdcd;">{{each.membership_name}}<span style="float:right; margin-right:10px; color:#cdcdcd;">종료</span></div>
                            <div style="font-size:12px; margin-top:5px; text-align:right;">&nbsp;</div>
                        </div>
                        <div style="position:relative; padding:15px 40px; padding-bottom:30px;background-color: white; border-bottom-right-radius: 10px; border-bottom-left-radius:10px; ">
                            <div style="font-size:17px; font-weight: bold; color:#cdcdcd; margin-top:5px;">{{$GlobalStore.loginInfo().name}}</div>
                            <div class="membership_info" style="margin-top:10px;">
                                <div class="membership_label">회원권</div><div class="membership_conts" style="color:#bbbbbb;">{{each.membership_name}}</div>
                            </div>
                            <div class="membership_info">
                                <div class="membership_label">기간</div><div class="membership_conts" style="color:#bbbbbb;">{{each.begin_date | ShortDotDate}} ~ {{each.end_date | ShortDotDate}}</div>
                            </div>
                            <div class="membership_info">
                                <div class="membership_label">회차</div><div class="membership_conts" style="color:#bbbbbb;">{{each.coupon_count == 0 ? '무제한' : parseInt(each.used_count) + '회 / ' + each.coupon_count + '회'}}</div>
                            </div>
                            <div style="left:-20px;" class="round"></div>
                            <div style="right:-20px;" class="round"></div>
                        </div>
                    </template>

                </div>
            </div>
            <div style="height:10px;"></div>
        </InfinityScroll>
    </div>
</template>

<script>
    import InfinityScroll from "../../common/InfinityScroll";
    import MyFeedHeader from "../../common/MyFeedHeader";
    export default {
        name: "MyMembershipsWithProgressing",
        components: {MyFeedHeader, InfinityScroll},
        data(){
            return {
                memberships : [],
            }
        },
        methods : {
            async getMemberships(){
                const res = await this.$Axios.get('/api/coach/member/memberships');
                this.memberships = res.data.memberships;
            },
            refresh(){
                this.getMemberships();
            }
        },
        created(){
            this.getMemberships();
        }
    }
</script>

<style scoped>
    .membership_wrap{padding:0px 20px; }
    .membership_wrap + .membership_wrap{
        margin-top:20px;
    }
    .membership_info{display:flex;}
    .membership_info + .membership_info{margin-top:8px;}
    .membership_label{font-size:13px; width:100px; color:#bbbbbb;}
    .membership_conts{font-size:13px; color:#464646; font-weight:bold;}
    .btns{display:inline-block; height:40px; font-size:15px; line-height:40px; border-radius:20px; width:140px;}
    .btns + .btns{margin-left:15px;}
    .round{position:absolute; top: 10px; width:40px; height:40px; border-radius:50%; background-color: #f2f2f2;}
</style>